const theme = {
    breakpoints: {
        xs: 0,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: 1500
    }
}

export default theme;